var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mini-logo text-center my-4"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../../assets/images/logo.png"),"alt":""}})]),_c('h4',{staticClass:"card-title mt-3"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }